<template>
  <div>
    <el-dialog title="服务"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open"
               width="500px">
      <div class="setContent">
        <div class="top">
          <div style="display:flex; align-item:flex-start">
            <span>科目名称：</span>
            <div style="width:200px;"
                 class="tag">
              <el-tag v-for="tag in tagList"
                      :key="tag.id"
                      closable
                      @close="tagClose(tag)"
                      type="success"
                      style="marginRight:8px;marginBottom:8px">
                <span v-if="tag.code.length==5">{{tag.name}}（院校）</span>
                <span v-if="tag.code.length==6">{{tag.code}}{{tag.name}}（专业）</span>
                <span v-if="tag.code.length==3">{{tag.code}}{{tag.name}}（科目）</span>

              </el-tag>
            </div>
          </div>
          <span @click="addSubject()"
                style="color: #409EFF; cursor: pointer; ">+添加服务科目</span>
        </div>
        <div style="marginTop:10px">
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="serviceClose">取 消</el-button>
        <el-button type="primary"
                   @click="serviceSubmit">保存</el-button>
      </div>
    </el-dialog>
    <div>
      <el-dialog title="新增服务科目"
                 :close-on-click-modal="false"
                 :visible.sync="subjectVisible"
                 @close="handleSubjectClose"
                 @open="subjectOpen"
                 width="500px">
        <div class="setContent">
          <el-form :model="dataForm"
                   label-position="left"
                   ref="formRules"
                   label-width="87px"
                   size="small">
            <el-form-item label="标签类型："
                          prop="default_greet_message">
              <el-select v-model="dataForm.tag_type "
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         @change="typeChange">
                <el-option v-for="(item, index) in filter.type"
                           :key="index"
                           :label="item.value"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取院校："
                          v-if="dataForm.tag_type == 1">
              <el-select v-model="dataForm.recruit_college_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录取专业"
                          v-if="dataForm.tag_type ==2">
              <div style="display:flex">
                <el-select v-model="marjorType"
                           filterable
                           collapse-tags
                           placeholder="请选择"
                           style="width:100px"
                           @change="Change">
                  <el-option v-for="(item, index) in type"
                             :key="index"
                             :label="item.name"
                             :value="item.id">
                    <span>{{ item.name }}</span>
                  </el-option>
                </el-select>
                <el-select v-model="dataForm.recruit_major_code"
                           filterable
                           collapse-tags
                           placeholder="请选择"
                           @change="majorChange">
                  <el-option v-for="(item, index) in majorList"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                    <span>{{ `（${item.code}）${item.name}` }}</span>
                  </el-option>
                </el-select>

              </div>
            </el-form-item>
            <el-form-item label="考试科目："
                          v-if="dataForm.tag_type ==3">
              <el-select v-model="dataForm.test_subject_codes"
                         filterable
                         remote
                         :remote-method="searchQuery"
                         :loading="loading"
                         collapse-tags
                         placeholder="请选择"
                         @change="subjectChange">
                <el-option v-for="(item, index) in subjectsList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{
                    `（${item.code}）${item.name}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="handleSubjectClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

</template>
<script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
  majorList,
  subjectList,
} from '@/api/common'
import { addTag, deletetag } from '@/api/senior'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tagDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dataForm: {},
      loading: false,
      dialogVisible: this.visible,
      subjectVisible: false,
      marjorType: '',
      majorList: [],
      academicList: [],
      professionalList: [],
      subjectsList: [],
      college_name: '',
      recruit_major_name: '',
      test_subject_name: [],
      tagList: [],
      type: [
        {
          id: 0,
          name: '学硕',
        },
        {
          id: 1,
          name: '专硕',
        },
      ],
      filter: {
        tags: [
          {
            id: 0,
            sensitive_word: 'hjahaj',
          },
        ],
        type: [
          {
            id: '1',
            value: '院校',
          },
          {
            id: '2',
            value: '专业',
          },
          {
            id: '3',
            value: '科目',
          },
        ],
      },
    }
  },
  methods: {
    // searchQuery() {
    searchQuery(query) {
      this.loading = true
      subjectList({
        subject: query,
        isPaging: 0,
        major_code: '065100',
      }).then((res) => {
        if (res) {
          this.subjectsList = res.list || []
          this.loading = false
        }

        console.log('reskemu', this.subjectsList)
      })
      // collegeList({ keyword: query, isPaging: 0 }).then(res => {
      //   if (res) {
      //     this.collegeList = res.list
      //   }
      //   this.loading = false
      // })
    },
    handleClose() {
      this.$emit('close')
      this.tagList = []
    },
    handleSubjectClose() {
      this.subjectVisible = false
    },
    tagClose(val) {
      if (val.id) {
        deletetag({
          servicer_tag_id: val.id,
        }).then((res) => {
          this.tagList = this.tagList.filter((v) => {
            return v.id != val.id
          })
          this.$emit('sumbit')
          this.$message.success(`删除成功`)
        })
      } else {
        this.tagList = this.tagList.filter((v) => {
          return v.id != val.id
        })
        this.$emit('sumbit')
      }
    },
    handleSubmit() {
      let data = {}
      if (this.dataForm.tag_type == '1') {
        this.$store.state.collegeList.map((item) => {
          if (item.code == this.dataForm.recruit_college_code) {
            this.college_name = item.name
          }
        })
        console.log('学校名称', this.college_name)
        data = {
          servicer_type: 2,
          servicer_id: this.tagDetail.id,
          tag_type: this.dataForm.tag_type,
          tag_code: this.dataForm.recruit_college_code,
          tag_name: this.college_name,
        }
        addTag(data).then((res) => {
          console.log('res', res)
          this.tagList.push({
            code: this.dataForm.recruit_college_code,
            name: this.college_name,
            id: res.insertId,
          })
          this.subjectVisible = false
          this.$message.success(`操作成功`)
        })
      } else if (this.dataForm.tag_type == '2') {
        console.log('this.majorList', this.majorList)
        this.majorList.map((v) => {
          if (v.code == this.dataForm.recruit_major_code) {
            this.recruit_major_name = v.name
          }
        })
        data = {
          servicer_type: 2,
          servicer_id: this.tagDetail.id,
          tag_type: this.dataForm.tag_type,
          tag_code: this.dataForm.recruit_major_code,
          tag_name: this.recruit_major_name,
        }
        addTag(data).then((res) => {
          console.log('res', res)
          this.subjectVisible = false
          this.tagList.push({
            code: this.dataForm.recruit_major_code,
            name: this.recruit_major_name,
            id: res.insertId,
          })
          this.$message.success(`操作成功`)
        })
      } else if (this.dataForm.tag_type == '3') {
        this.subjectsList.map((v) => {
          // this.dataForm.test_subject_codes.map((k) => {
          if (v.code == this.dataForm.test_subject_codes) {
            this.test_subject_name.push(v.name)
          }
          // })
        })
        data = {
          servicer_type: 2,
          servicer_id: this.tagDetail.id,
          tag_type: this.dataForm.tag_type,
          tag_code: this.dataForm.test_subject_codes,
          tag_name: this.test_subject_name.join(','),
        }
        // console.log(
        //   'this.dataForm.test_subject_codes',
        //   this.dataForm.test_subject_codes
        // )
        addTag(data).then((res) => {
          this.subjectVisible = false
          this.tagList.push({
            code: this.dataForm.test_subject_codes,
            name: this.test_subject_name.join(','),
            id: res.insertId,
          })
          this.$message.success(`操作成功`)
        })
      }
    },
    addSensitive() {},
    open() {
      console.log(
        'this.tagDetail.servicer_tag_list',
        this.tagDetail.servicer_tag_list
      )
      if (this.tagDetail.servicer_tag_list) {
        this.tagDetail.servicer_tag_list.map((item) => {
          this.tagList.push({
            code: item.tag_code,
            name: item.tag_name,
            id: item.id,
          })
        })
      }

      console.log('lll', this.tagDetail, this.tagList)
    },
    serviceSubmit() {
      this.tagList = []
      this.$emit('submit')
      this.handleClose()
    },
    serviceClose() {
      this.handleClose()
    },
    Change(e) {
      // 学硕
      if (e == 0) {
        majorList().then((res) => {
          console.log('res', res)
          res.list[0].children.map((item) => {
            item.children.map((v) => {
              v.children.map((k) => {
                this.majorList.push({
                  code: k.code,
                  name: k.name,
                })
              })
            })
          })
        })
      } else {
        majorList().then((res) => {
          res.list[1].children.map((item) => {
            item.children.map((v) => {
              v.children.map((k) => {
                this.majorList.push({
                  code: k.code,
                  name: k.name,
                })
              })
            })
          })
        })
      }
    },
    subjectOpen() {
      this.$store.dispatch('getAllColleges')
    },
    addSubject() {
      this.subjectVisible = true
    },
    typeChange(e) {
      console.log('e', e)
      console.log('dataForm.servicer_type', this.dataForm.servicer_type)
      if (e == 2) {
        this.majorList = []
      } else if (e == 3) {
        subjectList({
          pageIndex: 1,
          pageSize: 10,
          isPaging: 1,
          major_code: '065100',
        }).then((res) => {
          this.subjectsList = res.list || []
          console.log('reskemu', this.subjectsList)
        })
      }
    },
    collegeChange(e) {
      console.log('e', e)
      console.log('院校', this.dataForm.recruit_college_code)
    },
    majorChange(e) {
      console.log('e', e)
      this.majorList.map((item) => {
        if (item.code == e) {
          this.recruit_major_name = item.name
        }
      })
      console.log('专业名称', this.recruit_major_name)
    },
    subjectChange(e) {
      console.log('e', e)
      console.log('科目', this.dataForm.test_subject_codes)
      console.log('科目名称', this.test_subject_name)
    },
  },
}
</script>
<style lang="less" scoped>
.setContent {
  .top {
    display: flex;
    justify-content: space-between;
  }
  .tag {
    // display: flex;
    // flex-flow: row-reverse;
    // border: 1px solid red;
  }
}
</style>

